import "./sentry";
import "./posthog";
import "./lib/supabase";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { logAppVersion } from "./lib/appVersion";
import { tryEmailTokenLogin } from "./lib/emailTokenLogin";

logAppVersion();

async function boot() {
  // Exchange ?token= before React mounts so authBridge sees a Supabase session.
  await tryEmailTokenLogin();

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

void boot();